export default () =>
  Math.random()
    .toString(36)
    .substring(7)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/utils/getUuid.js